import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { PurchaseOrderDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/PurchesOrders/purchase-order-dto';
import { PurchaseOrderLineItemDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/PurchaseOrderLineItems/purchase-order-line-item-dto';
import { SupplierDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Suppliers/supplier-dto';
import { StockItemDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/StockItem/stock-item-dto';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { InventoryActionStatus } from 'src/app/pos-panel/enums/inventory-action-status.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentVenueHelperService } from 'src/app/share-modul/services/current-venue-helper/current-venue.helper.service';
import { Subscription } from 'rxjs';
import { InventoryService } from 'src/api/generated/services';
import { GetPurchaseOrder$Params } from 'src/api/generated/fn/inventory/get-purchase-order';
import { CancelPurchaseOrder$Params } from 'src/api/generated/fn/inventory/cancel-purchase-order';

@Component({
  selector: 'app-purchase-order-details',
  templateUrl: './purchase-order-details.component.html',
  styleUrls: ['./purchase-order-details.component.scss']
})
export class PurchaseOrderDetailsComponent implements OnInit, OnDestroy {

  purchaseOrder: PurchaseOrderDto = {} as PurchaseOrderDto;
  venueId: string;
  inventoryId: string;
  purchaseOrderId: string;
  venueIdUpdateSubscription: Subscription;
  InventoryActionStatus = InventoryActionStatus;
  timezoneOffset: any;

  constructor(private _location: Location,
              private route: ActivatedRoute,
              private router: Router,
              private confirmationService: ConfirmationService,
              public translate: TranslateService,
              private currentVenueHelper: CurrentVenueHelperService,
              private inventoryService: InventoryService,
              private messageService: MessageService) { 
    this.purchaseOrder.lineItems = new Array<PurchaseOrderLineItemDto>();
  }

  ngOnInit(): void {
    this.route.params.subscribe( params => {
      if (params['venue-id'] != null) {
        this.venueId = params['venue-id'];
        this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
        this.currentVenueHelper.getTimezone().subscribe(tzOffset => this.timezoneOffset = tzOffset)
      }
      if (params['inventory-id'] != null  && params['purchase-order-id']) {
        this.inventoryId = params['inventory-id'];
        this.purchaseOrderId = params['purchase-order-id'];
        
        const fetchParams: GetPurchaseOrder$Params = { inventoryId: this.inventoryId, purchaseOrderId: this.purchaseOrderId };
        this.inventoryService.getPurchaseOrder(fetchParams).subscribe(response => this.purchaseOrder = response)
      }
    });
  
  }

  public cancelOrder(){
    this.confirmationService.confirm({
      header: this.translate.instant('PURCHASE_ORDER.CONFIRMATION_DIALOG_CANCEL_ORDER_TITLE'),
      message: this.translate.instant('PURCHASE_ORDER.CONFIRMATION_DIALOG_CANCEL_ORDER_QUESTION'),
      acceptLabel: this.translate.instant('YES'),
      rejectLabel: this.translate.instant('NO'),
      defaultFocus: "reject",
      acceptButtonStyleClass: 'soc-confirmation-dialog dialog-btn destructive-btn',
      rejectButtonStyleClass: 'soc-confirmation-dialog dialog-btn reject-btn',
      accept: () => {
        const params: CancelPurchaseOrder$Params = { inventoryId: this.inventoryId, purchaseOrderId: this.purchaseOrderId };
        this.inventoryService.cancelPurchaseOrder(params).subscribe({
          next: response => {
            this.messageService.add({severity:'success', summary:'Order was succesfully cancelled!', life:3000});
            this.navigateToMain();
          },
          error: errorResponse => {
              if(errorResponse.error.StatusCode == -402){
                this.messageService.add({severity:'error', summary:'This purchase order is not pending and cannot be cancelled! ', life:3000})
              }
          }
        });
      }
    });
  }
  
  navigateToMain() {
    this.router.navigate([this.venueId, "inventory", this.inventoryId], { queryParams: { activeIndex: 1 }});
  }

  public ngOnDestroy(): void {
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }
}
